import type { BoxProps } from '@chakra-ui/react'
import { useToken } from '@chakra-ui/react'
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'

export interface CircularProgressProps extends BoxProps {
  percentage?: number
  color?: string
}

export const CircularProgress = ({
  percentage = 0,
  color = 'primary.500'
}: CircularProgressProps) => {
  const [trackColor, progressColor] = useToken(
    // the key within the theme, in this case `theme.colors`
    'colors',
    // the subkey(s), resolving to `theme.colors.red.100`
    ['gray.100', color],
    // a single fallback or fallback array matching the length of the previous arg
  )

  const normalizedPercentage = Math.min(Math.max(percentage, 0), 100)

  const data = [
    { name: 'Progress', value: normalizedPercentage, fill: progressColor, stroke: progressColor },
    { name: 'Remaining', value: 100 - normalizedPercentage, fill: trackColor, stroke: trackColor },
  ]

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart width={100} height={100}>
        <Pie
          data={data}
          dataKey="value"
          innerRadius='83%'
          outerRadius='100%'
          cornerRadius={3}
          animationBegin={0}
          animationDuration={800}
          strokeWidth={0}
          startAngle={90}
          endAngle={-270}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill} stroke={entry.stroke} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  )
}
